module.exports = __webpack_public_path__ + "static/media/Duplicate.d21c217d.png";